import React from "react";
import { Link, useLocation } from "react-router-dom";

// Catch-all route: an unknown path used to render nothing, i.e. a blank white page.
function NotFound() {
  const location = useLocation();
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: 480,
        margin: "40px auto",
        padding: "0 20px",
        textAlign: "center",
      }}
    >
      <h2>Page not found</h2>
      <p>
        This page doesn't exist or you don't have access to it. If you got here
        right after logging in, please send a screenshot of this page to the
        league admin.
      </p>
      <p>
        <Link to="/player/dashboard">Go to my dashboard</Link>
        {" · "}
        <Link to="/">Home</Link>
      </p>
      <pre
        style={{
          marginTop: 24,
          textAlign: "left",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontSize: 12,
          color: "#666",
        }}
      >
        {`Path: ${location.pathname}${location.search}`}
        {`\nTime: ${new Date().toISOString()}`}
        {`\nBrowser: ${navigator.userAgent}`}
      </pre>
    </div>
  );
}

export default NotFound;
